export default __webpack_public_path__ + "static/media/EvertRuales.4d7c1cbd.webp";